import Resource from '@/api/resources/Resource'

class SampleCodificationServices extends Resource {
    async getCodifications(labId, caseId, samId) {
        const response = await this.axios.get(`/laboratories/${labId}/cases/${caseId}/samples/${samId}/codifications`)
        return response.data
    }
    async createBatchCodifications(labId, caseId, samId, codificationRequests) {
        const response = await this.axios.post(`/laboratories/${labId}/cases/${caseId}/samples/${samId}/codifications/createBatch`, codificationRequests)
        return response.data
    }
    async deleteBatchCodifications(labId, caseId, samId, codificationIds) {
        const params = {
            entityIdentifiers: codificationIds.map(codification => codification.id)
        }
        const response = await this.axios.delete(`/laboratories/${labId}/cases/${caseId}/samples/${samId}/codifications/deleteBatch`, { data: params })
        return response.data
    }
    async updateBatchCodifications(labId, caseId, samId, updateRequests) {
        const response = await this.axios.put(`/laboratories/${labId}/cases/${caseId}/samples/${samId}/codifications/updateBatch`, updateRequests)
        return response.data
    }
}

export default new SampleCodificationServices()
